// Menu
$('.menu-button').click(function(){
$('.menu-container').toggleClass("show");
});
$('.menu-close').click(function(){
$('.menu-container').toggleClass("show");
});
$('.menu-list-1 a').click(function(){
$('.menu-container').toggleClass("show");
});
$('.menu-list-2 a').click(function(){
$('.menu-container').toggleClass("show");
});
$('.menu-list-cart a').click(function(){
$('.menu-container').toggleClass("show");
});
// Slideshow
$(document).ready(function(){
  $('.featuredimages').slick({
	  infinite: true,
	  slidesToShow: 1,
	  dots: false,
	  prevArrow: false,
	  nextArrow: false,
	  dots: true,
	  fade: true,
	  fadeSpeed: 1000
  });
});
$(document).ready(function(){
$('.featuredimages').click(function(){
$(this).slick('slickNext');
});
});